import { jsxs as l, jsx as h } from "react/jsx-runtime";
const c = (v) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...v,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M50 20H17.47C15.55 20 14 21.56 14 23.47v3.05c0 1.92 1.56 3.47 3.47 3.47H50V20Zm-22.5 2h3.51v6H27.5v-6Zm-2 6h-3.51v-6h3.51v6Zm7.51-6h3.51v6h-3.51v-6Zm5.51 0h3.51v6h-3.51v-6ZM16 26.53v-3.05c0-.81.66-1.47 1.47-1.47h2.52v6h-2.52C16.66 28 16 27.34 16 26.53ZM48 28h-3.97v-6H48v6ZM14 40.29c0 2.62 2.24 4.74 5 4.74s5-2.12 5-4.74-2.24-4.74-5-4.74-5 2.12-5 4.74Zm8 0c0 1.51-1.35 2.74-3 2.74s-3-1.23-3-2.74c0-1.51 1.35-2.74 3-2.74s3 1.22 3 2.74ZM27 40.27c0 2.62 2.24 4.74 5 4.74s5-2.12 5-4.74-2.24-4.74-5-4.74-5 2.12-5 4.74Zm8 0c0 1.51-1.35 2.74-3 2.74s-3-1.23-3-2.74c0-1.51 1.35-2.74 3-2.74s3 1.23 3 2.74Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M58 46.92V12H9.51C7.57 12 6 13.57 6 15.51V48c0 2.21 1.79 4 4 4h45.07L54 48H10V16h44v32l4-1.08Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M50.53 41.29v-.03L50 39.29h-8.59l.54 2h8.58Z"
        }
      )
    ]
  }
);
export {
  c as MeterReading
};
